import { client } from './client';

export function apiGetSelf() {
  const headers = {
    'Content-Type': 'application/json',
  };
  return client.get('users/self');
}
